<script>
	import Dispatch from './Dispatcher'
	import { faLockAlt, faWallet, faHandHoldingUsd, faPlay, faStop, faPlus, faSolarSystem, faFire, faSparkles } from '@fortawesome/pro-solid-svg-icons'
	import { faSmile } from '@fortawesome/pro-regular-svg-icons'
	import 'codemirror/lib/codemirror.css'
	import 'codemirror/mode/javascript/javascript'
	import CodeMirror from './components/CodeMirror.svelte'
	import Fa from 'svelte-fa'
	import { withLatestFrom, map, tap, filter, startWith  } from 'rxjs/operators';
	import { combineLatest } from 'rxjs';
	import _ from 'lodash'
	import ScaleTool from './components/ScaleTool.svelte'
	import PlayPacer from './components/PlayPacer.svelte'
	import Thumb from './components/thumb/Thumb.svelte'
	import Simulator from './components/Simulator.svelte'
	import CommandOptions from './components/CommandOptions.svelte'
	import playTime from './engines/clock'
	import CodeInstructions from './components/instructions/CodeInstructions.svelte'

	const scaleWidth = 250
//	const songLength = 180000

	// Every 1 second
//	const seconds = songLength / 1000
	const secondsArray = Dispatch.getState('view.songLength')
		.pipe(
			map(e => {
				return new Array(parseInt(e / 1000))
			})
		)


	const playing = Dispatch.getState('view.playing')

	const percentScale = Dispatch.getState('view.scale.percentScale')
		.pipe(
			map(e => scaleWidth * e)
		)

		const percentScaleSpeed = Dispatch.getState('view.speed')
		.pipe(
			map(e => scaleWidth * e)
		)

	const windowWidth = Dispatch.getState('view.scale.windowWidth')

	const tickPadding = Dispatch.getState('view.scale.tickPadding')

	const scale = Dispatch.getState('view.scale')

	const state = Dispatch.getState('view.mode')
	
	let loadedCode = null
	let showcode = false

	const code = Dispatch.getState('layers')
		.pipe(
			map(e => JSON.stringify(e)),
			tap(e => loadedCode = e)
		)
		.subscribe()

	Dispatch.getState('parsedCode')
			.subscribe(e => console.log(e))

	// Dispatch.getAction('setElapsed')
	// 	.pipe(
	// 		withLatestFrom(windowWidth, Dispatch.getState('view.scale.songLength')),
	// 		map(e => (e[0] / e[1]) * e[2]),
	// 	)
	// 	.subscribe(e => Dispatch.nextState('view.elapsed', e))

	let layers = Dispatch.getState('layers')
		.pipe(
			map(layers => {
				const uniqueLayers = _.sortBy(_.uniqBy(layers, 'layer'), layer => layer.layer)
				return uniqueLayers.map(layer => ({id: layer.layer, commands: _.filter(layers, command => command.layer === layer.layer )} ))
			}),
		)

	const selected = Dispatch.getState('view.details.selected.id')

	const selectedCommand = combineLatest(Dispatch.getState('layers'), Dispatch.getState('view.details.selected.id'))
		.pipe(
			map(([layers, selected]) => _.find(layers, command => command.id === selected)),
		)

	const cursor = combineLatest(state, Dispatch.getState('view.mouseDown'))
			.pipe(
				map(([state, mouseDown]) => (state === 'delete' && mouseDown === 1) ? 'crosshair' : (state === 'delete') ? 'no-drop' : 'auto'),
			)

	let songURL = ''

	// CodeMirror
	const options = {
		mode: "javascript",
		lineNumbers: true,
	}
	
	let codemirrortext = ``
	let editor
	let visualEditor
	let defaultValue = Dispatch.getState('writtenCode')

	const visualMode = Dispatch.getState('view.visual')

</script>

<main class='pa2'>
		<div class='w-100 ph4 pv3  flex justify-between items-center bg-dark-gray white overflow-x-scroll'>
			<div class='flex flex-column'>
				<div class='' style='width: 250px;'>
					<img src='ETLightsSmallLogo.svg' />
				</div>
				<div class='pt3 flex items-center'>
					<div class='flex pa3 ba b--gray br3 items-center justify-center flex-column'>
						<div class=' pa2 bg-red white br3 f6' on:click={e => {
							var confirmed = confirm('Are you sure you want to clear your light show back to the default starting settings? If you are sure, click okay.')
							if (confirmed == true) {
								Dispatch.nextAction('script.clear')
							}
						}}>
							Clear
						</div>
						<div class='mt2 pa2 bg-green white br3 f6' on:click={async e => { showcode = true; await setTimeout(1); window.scrollTo(0,document.body.scrollHeight); }}>
							Save
						</div>
						<div class='mt2 pa2 bg-green white br3 f6' on:click={async e => { showcode = true; await setTimeout(1); window.scrollTo(0,document.body.scrollHeight); }}>
							Import
						</div>
					</div>
					<div class='ml4 flex flex-column items-center justify-center'>
						<div class='fw8'>Cursor Mode</div>
						<div class='mt2 ph3 pv2 flex items-center f6 ba b--gray br3'>
							<!-- <div class={' pointer ' + ($state === 'add' ? ' pa2 bg-green br3 white ' : ' black ')} on:click={e => Dispatch.nextState('view.mode', 'add')}>Add</div> -->
							<div class={'ml2 pointer '+ ($state === 'options' ? ' pa2 bg-green br3 white ' : ' white ')} on:click={e => Dispatch.nextState('view.mode', 'options')}>None</div>
							<div class={'ml2 pointer ' + ($state === 'delete' ? ' pa2 bg-yellow br3 white ' : ' white ')} on:click={e => Dispatch.nextState('view.mode', 'delete')}>Eraser</div>
							<!-- <div class={'ml2 pointer '+ ($state === 'options' ? ' pa2 bg-green br3 white ' : ' black ')} on:click={e => Dispatch.nextState('view.mode', 'options')}>Options</div> -->
						</div>
						<div class='pt3 fw8'>Edit Mode</div>
						<div class='mt2 ph3 pv2 flex items-center f6 ba b--gray br3'>
							<!-- <div class={' pointer ' + ($state === 'add' ? ' pa2 bg-green br3 white ' : ' black ')} on:click={e => Dispatch.nextState('view.mode', 'add')}>Add</div> -->
							<div class={'ml2 pointer '+ ($visualMode ? ' pa2 bg-green br3 white ' : ' white ')} on:click={e => Dispatch.nextState('view.visual', true)}>Visual</div>
							<div class={'ml2 pointer ' + (!$visualMode ? ' pa2 bg-green br3 white ' : ' white ')} on:click={e => Dispatch.nextState('view.visual', false)}>Code</div>
							<!-- <div class={'ml2 pointer '+ ($state === 'options' ? ' pa2 bg-green br3 white ' : ' black ')} on:click={e => Dispatch.nextState('view.mode', 'options')}>Options</div> -->
						</div>
					</div>
				</div>
			</div>
			<div>
			
				<div class='f1 ph2 flex flex-column items-center '>
					{#if $playing}
						<div class='red ph4' on:click={e => Dispatch.nextAction('pause')}>
							<Fa icon={faStop}/>
						</div>
					{:else}
						<div class='green ph4' on:click={e => Dispatch.nextAction('start')}>
							<Fa icon={faPlay}/>
						</div>
					{/if}
					<div class='pt3 f5'>{parseInt(isNaN($playTime) ? 0 : $playTime)}</div>
					<!-- <div class='f5 pa3'>Add Item</div> -->
				</div>
			</div>
			<Simulator size=25/>
			<div class='pl4 flex flex-column justify-center items-center'>
				<div class='pb4 flex items-end'>
					<div class='flex flex-column'>
						<div class='f6 fw7'>Song URL</div>
						<input class='mt1 ph2 pv1 br3' bind:value={songURL}>
					</div>
					<div class=' ml2 bg-blue white br3 pa2 fw7 f6 tc flex items-center' style='height:30px' on:click={e => Dispatch.nextAction('loadSong', songURL)}>Load</div>
				</div>
				<ScaleTool callback={e => Dispatch.nextState('view.scale.percentScale', e)} name='Scale' percentScale={$percentScale} scaleWidth={scaleWidth}/>
				<ScaleTool callback={e => Dispatch.nextState('view.speed', (e > .1) ? e : .1)} name='Speed' percentScale={$percentScaleSpeed} scaleWidth={scaleWidth}/>
				<div class='ph3 w-100 flex justify-between'>
					<div class=''></div>
					<div class='relative f6 fw3' style='top:-5px' on:click={e => Dispatch.nextState('view.speed', 1)}>Normal</div>
				</div>
			</div>
		</div>
		
		<div class='flex'>

		{#if $visualMode}
			<div id='scripter' class='relative w-100 overflow-x-scroll' >
				<PlayPacer />
				<div class='relative flex items-center bt b--light-gray bg-black' style={'height: 40px; width: ' + $windowWidth + 'px;'} on:click={e => Dispatch.nextAction('scrub', e.offsetX)}>
					{#each $secondsArray ?? [] as second, i}
						<div class='absolute f7 light-gray ' style={'pointer-events: none; left: '+ ($tickPadding * i) + 'px;'} on:click={e => {e.preventDefault();}} >{(i)}</div>
					{/each}
				</div>
				<div class='w-100 bg-dark-gray white flex flex-column' style={'width: ' + $windowWidth + 'px; cursor: ' + $cursor + ';'} on:click={e => Dispatch.nextAction('scrub', e.offsetX)}>
					{#each $layers || [] as layer}


						{#if $selectedCommand?.layer === layer.id}
							<CommandOptions selectedCommand={$selectedCommand}/>
						{/if}


						<!-- on:click={e => Dispatch.nextAction('script.add.fromClick', { layer: layer.id, position: e.offsetX })}  -->
						<div 
							id='base' 
							class={'relative pv2 bt b--white flex items-center ' + ($state === 'delete' ? ' bg-yellow ' : ' bg-blue ') }
							on:dragend={e => e.preventDefault()}
							style={'height: 90px;'} on:drop={e => console.log(e)} on:dragover={e => e.preventDefault()} on:dragenter={e => console.log("ENTER")}
						>
							{#each layer?.commands || [] as command }
								<Thumb selected={$selected} command={command}/>
							{/each}
						</div>
					{/each}
				</div>
		</div>
	{/if}
	{#if !$visualMode}
	<div class ='w-100 flex flex-column'>
		<div id='scripter' class='relative w-100 overflow-x-scroll' >
			<PlayPacer />
			<div class='relative flex items-center bt b--light-gray bg-black' style={'height: 40px; width: ' + $windowWidth + 'px;'} on:click={e => Dispatch.nextAction('scrub', e.offsetX)}>
				{#each $secondsArray ?? [] as second, i}
					<div class='absolute f7 light-gray ' style={'pointer-events: none; left: '+ ($tickPadding * i) + 'px;'} on:click={e => {e.preventDefault();}} >{(i)}</div>
				{/each}
			</div>
		</div>
		<CodeMirror bind:editor {options} class="w-100 editor" bind:value={codemirrortext} defaultValue={$defaultValue} onChange={(value) =>Dispatch.nextState('writtenCode', value)} />
		</div>
	{/if}

</main>

<div class='w-100 flex justify-between pv2 ph4 '>
	<div></div>
	<div class='dib pa3 white bg-blue br-100 ' on:click={e => Dispatch.nextAction('script.newLayer')}><Fa icon={faPlus}/></div>
</div>
<div class='w-100 ph3 white flex flex-column items-center justify-center'>
	<div>
		{#if !$visualMode}
			<div class='mw6'>
				<CodeInstructions />
			</div>
		{:else}
			<div class='w-100 f3 orange fw8 tc'>CHEAT SHEET</div>
			<div class='mw6'>
				<div class='pt3 flex items-center f5 fw7'>
					<div class='f3'><Fa icon={faSolarSystem}/></div>
					<div class='pl2 '>Spiral</div>
				</div>
				<div class='f6 pt1 fw4'>Turns on and off each individual light in a group one after another.</div>
			</div>
			<div class='mw6'>
				<div class='pt3 flex items-center f5 fw7'>
					<div class='f3'><Fa icon={faFire}/></div>
					<div class='pl2 '>Flash</div>
				</div>
				<div class='f6 pt1 fw4'>Turns on and off all lights in a group.</div>
			</div>
			<div class='mw6'>
				<div class='pt3 flex items-center f5 fw7'>
					<div class='f3'><Fa icon={faSparkles}/></div>
					<div class='pl2 '>Twinkle</div>
				</div>
				<div class='f6 pt1 fw4'>Turns on and off all lights in a group.</div>
			</div>
			<div class='mw6'>
				<div class='pt3 flex items-center f5 fw7'>
					<div class=' '>Key: Backspace</div>
				</div>
				<div class='f6 pt2 fw4'>If a command is selected, the backspace key will delete it.</div>
			</div>
		{/if}
	</div>
</div>
<!-- <Simulator /> -->
<div class='pt5'></div>
{#if $visualMode}
	{#if !showcode}
		<div class='flex items-center justify-center'>
			<div class='pa3 br3 bg-green white' on:click={e => { showcode = true }}>Show Code</div>
		</div>
		{:else}
		<div class='flex items-center justify-center'>
			<div class='pa3 br3 bg-green white' on:click={e => { showcode = false }}>Hide Code</div>
		</div>
			<div class='w-100 mb5 pb5 ph4 flex flex-column items-center'>
			<div class='mt4 white f2'>Copy or Paste To Save/Import</div>
			<!-- <div contenteditable=true class='mt3 w-100 pa3 br3 bg-white' bind:innerHTML={loadedCode}/> -->
			<CodeMirror bind:visualEditor {options} class="w-100 editor" bind:value={loadedCode} />
			<div class='mt3 br3 pa3 white bg-red' on:click={e => {
				console.log(loadedCode)
				Dispatch.nextState('layers', JSON.parse(loadedCode))
			}}>Import</div>
		</div>
	{/if}
{/if}

<div class='pt5'></div>
<style>

	@media (min-width: 640px) {
		main {
			max-width: none;
		}
	}
</style>